"use client";

import { useActionState } from "react";
import { login } from "./actions";

export function LoginForm() {
  const [state, action, pending] = useActionState(login, undefined);

  return (
    <form action={action} className="flex flex-col gap-4">
      <label className="flex flex-col gap-1 text-sm font-medium">
        Adresse e-mail
        <input
          className="rounded-xl border border-zinc-300 px-4 py-3 outline-none focus:border-blue-500"
          type="email"
          name="email"
          autoComplete="username"
          required
          autoFocus
        />
      </label>

      <label className="flex flex-col gap-1 text-sm font-medium">
        Mot de passe
        <input
          className="rounded-xl border border-zinc-300 px-4 py-3 outline-none focus:border-blue-500"
          type="password"
          name="password"
          autoComplete="current-password"
          required
        />
      </label>

      {state?.error && (
        <p className="rounded-xl bg-red-50 px-4 py-3 text-sm text-red-700">
          {state.error}
        </p>
      )}

      <button
        className="rounded-xl bg-blue-600 px-5 py-3 font-semibold text-white hover:bg-blue-700 disabled:bg-blue-300"
        type="submit"
        disabled={pending}
      >
        {pending ? "Connexion…" : "Se connecter"}
      </button>
    </form>
  );
}
